import * as angular from 'angular';

import { TicketType, ActionResponseDto } from '../../models';
import { IRequestService } from '../request.service';

export interface ITicketTypesService {
    getAll(force?: boolean): angular.IPromise<TicketType[]>;
}

export class TicketTypesService implements ITicketTypesService {

    static serviceId = 'ticketTypesService';
    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getAll(force?: boolean): angular.IPromise<TicketType[]> {
        const url = 'ticket/getTicketTypes';

        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }

        return this._requestService
            .getAtV1<ActionResponseDto<TicketType[]>>(url)
            .then(data => {
                if (data.isSuccessful) {
                    return data.items;
                } else {
                    throw data.message;
                }
            })
            .catch(error => {
                return error;
            });
    }
}